import D, { useRef as K, useState as tt, useEffect as jt, useCallback as Pt, useMemo as Ot, createContext as Ue, useContext as Ye, forwardRef as _e, Fragment as Qe } from "react";
import { z as y, h as It, p as Xe, v as Ze, L as qe, x as Ke, S as Je, j as tn, Q as Gt, V as ht, U as Ut, w as Yt } from "./index2.js";
import { m as b, E as en, L as nn, F as h, o as Oe, A as xt } from "./index4.js";
import { b as rn, e as on } from "./index3.js";
function an(t, n) {
  var e = K(null), r = K(null);
  r.current = n;
  var o = K(null);
  jt(function() {
    i();
  });
  var i = Pt(function() {
    var l = o.current, u = r.current, c = l || (u ? u instanceof Element ? u : u.current : null);
    e.current && e.current.element === c && e.current.subscriber === t || (e.current && e.current.cleanup && e.current.cleanup(), e.current = {
      element: c,
      subscriber: t,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: c ? t(c) : void 0
    });
  }, [t]);
  return jt(function() {
    return function() {
      e.current && e.current.cleanup && (e.current.cleanup(), e.current = null);
    };
  }, []), Pt(function(l) {
    o.current = l, i();
  }, [i]);
}
function _t(t, n, e) {
  return t[n] ? t[n][0] ? t[n][0][e] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    t[n][e]
  ) : n === "contentBoxSize" ? t.contentRect[e === "inlineSize" ? "width" : "height"] : void 0;
}
function cn(t) {
  t === void 0 && (t = {});
  var n = t.onResize, e = K(void 0);
  e.current = n;
  var r = t.round || Math.round, o = K(), i = tt({
    width: void 0,
    height: void 0
  }), l = i[0], u = i[1], c = K(!1);
  jt(function() {
    return c.current = !1, function() {
      c.current = !0;
    };
  }, []);
  var d = K({
    width: void 0,
    height: void 0
  }), g = an(Pt(function(p) {
    return (!o.current || o.current.box !== t.box || o.current.round !== r) && (o.current = {
      box: t.box,
      round: r,
      instance: new ResizeObserver(function(E) {
        var j = E[0], H = t.box === "border-box" ? "borderBoxSize" : t.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", L = _t(j, H, "inlineSize"), N = _t(j, H, "blockSize"), W = L ? r(L) : void 0, k = N ? r(N) : void 0;
        if (d.current.width !== W || d.current.height !== k) {
          var G = {
            width: W,
            height: k
          };
          d.current.width = W, d.current.height = k, e.current ? e.current(G) : c.current || u(G);
        }
      })
    }), o.current.instance.observe(p, {
      box: t.box
    }), function() {
      o.current && o.current.instance.unobserve(p);
    };
  }, [t.box, r]), t.ref);
  return Ot(function() {
    return {
      ref: g,
      width: l.width,
      height: l.height
    };
  }, [g, l.width, l.height]);
}
function ln(t, n) {
  return function(e) {
    if (Array.isArray(e))
      return e;
  }(t) || function(e, r) {
    var o = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (o != null) {
      var i, l, u, c, d = [], g = !0, p = !1;
      try {
        if (u = (o = o.call(e)).next, r === 0) {
          if (Object(o) !== o)
            return;
          g = !1;
        } else
          for (; !(g = (i = u.call(o)).done) && (d.push(i.value), d.length !== r); g = !0)
            ;
      } catch (E) {
        p = !0, l = E;
      } finally {
        try {
          if (!g && o.return != null && (c = o.return(), Object(c) !== c))
            return;
        } finally {
          if (p)
            throw l;
        }
      }
      return d;
    }
  }(t, n) || function(e, r) {
    if (e) {
      if (typeof e == "string")
        return Qt(e, r);
      var o = Object.prototype.toString.call(e).slice(8, -1);
      if (o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set")
        return Array.from(e);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
        return Qt(e, r);
    }
  }(t, n) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Qt(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var e = 0, r = new Array(n); e < n; e++)
    r[e] = t[e];
  return r;
}
var xe = Ue({ containerWidth: void 0 }), Rn = function() {
  return Ye(xe);
};
function Xt(t) {
  var n = t.children, e = ln(tt(), 2), r = e[0], o = e[1], i = cn({ onResize: function(l) {
    var u = l.width;
    o(u);
  } }).ref;
  return D.createElement(xe.Provider, { value: { containerWidth: r } }, D.createElement("div", { style: { width: "100%" }, ref: i }, n));
}
Xt.displayName = "LeafyGreenChatProvider", Xt.propTypes = { children: y.node };
function O(t, n, e) {
  return (n = function(r) {
    var o = function(i, l) {
      if (typeof i != "object" || i === null)
        return i;
      var u = i[Symbol.toPrimitive];
      if (u !== void 0) {
        var c = u.call(i, l || "default");
        if (typeof c != "object")
          return c;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (l === "string" ? String : Number)(i);
    }(r, "string");
    return typeof o == "symbol" ? o : String(o);
  }(n)) in t ? Object.defineProperty(t, n, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : t[n] = e, t;
}
function St() {
  return St = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, St.apply(this, arguments);
}
function un(t, n) {
  if (t == null)
    return {};
  var e, r, o = function(l, u) {
    if (l == null)
      return {};
    var c, d, g = {}, p = Object.keys(l);
    for (d = 0; d < p.length; d++)
      c = p[d], u.indexOf(c) >= 0 || (g[c] = l[c]);
    return g;
  }(t, n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (r = 0; r < i.length; r++)
      e = i[r], n.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(t, e) && (o[e] = t[e]);
  }
  return o;
}
function C(t, n) {
  return n || (n = t.slice(0)), Object.freeze(Object.defineProperties(t, { raw: { value: Object.freeze(n) } }));
}
var Zt, qt, Kt, Jt, te, ee, ne, _, re, oe, ie, ae, ce, le, Q, bt, x = { DarkGray: "darkgray", LightGray: "lightgray", Red: "red", Yellow: "yellow", Blue: "blue", Green: "green" }, sn = b(Zt || (Zt = C([`
  font-family: `, `;
  display: inline-flex;
  align-items: center;
  font-weight: `, `;
  font-size: 12px;
  line-height: 16px;
  border-radius: 24px;
  height: 18px;
  padding-left: 6px;
  padding-right: 6px;
  text-transform: uppercase;
  border: 1px solid;
  letter-spacing: 0.4px;
`])), en.default, nn.bold), fn = (O(bt = {}, It.Dark, (O(_ = {}, x.LightGray, b(qt || (qt = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.gray.dark1, h.gray.base, h.gray.light3)), O(_, x.DarkGray, b(Kt || (Kt = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.gray.dark3, h.gray.dark2, h.gray.light2)), O(_, x.Red, b(Jt || (Jt = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.red.dark3, h.red.dark2, h.red.light2)), O(_, x.Yellow, b(te || (te = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.yellow.dark3, h.yellow.dark2, h.yellow.light2)), O(_, x.Blue, b(ee || (ee = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.blue.dark2, h.blue.dark1, h.blue.light2)), O(_, x.Green, b(ne || (ne = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.green.dark3, h.green.dark2, h.green.light1)), _)), O(bt, It.Light, (O(Q = {}, x.LightGray, b(re || (re = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.gray.light3, h.gray.light2, h.gray.dark1)), O(Q, x.DarkGray, b(oe || (oe = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.gray.dark2, h.gray.dark3, h.white)), O(Q, x.Red, b(ie || (ie = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.red.light3, h.red.light2, h.red.dark2)), O(Q, x.Yellow, b(ae || (ae = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.yellow.light3, h.yellow.light2, h.yellow.dark2)), O(Q, x.Blue, b(ce || (ce = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.blue.light3, h.blue.light2, h.blue.dark1)), O(Q, x.Green, b(le || (le = C([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;
    `])), h.green.light3, h.green.light2, h.green.dark2)), Q)), bt), dn = ["children", "variant", "className", "darkMode"];
function ue(t) {
  var n = t.children, e = t.variant, r = e === void 0 ? x.LightGray : e, o = t.className, i = t.darkMode, l = un(t, dn), u = Xe(i).theme;
  return D.createElement("div", St({}, l, { className: Oe(sn, fn[u][r], o) }), n);
}
ue.displayName = "Badge", ue.propTypes = { darkMode: y.bool, className: y.string, children: y.node, variant: y.oneOf(Object.values(x)) };
function se(t, n) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function et(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = arguments[n] != null ? arguments[n] : {};
    n % 2 ? se(Object(e), !0).forEach(function(r) {
      f(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : se(Object(e)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
function f(t, n, e) {
  return (n = function(r) {
    var o = function(i, l) {
      if (typeof i != "object" || i === null)
        return i;
      var u = i[Symbol.toPrimitive];
      if (u !== void 0) {
        var c = u.call(i, l || "default");
        if (typeof c != "object")
          return c;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (l === "string" ? String : Number)(i);
    }(r, "string");
    return typeof o == "symbol" ? o : String(o);
  }(n)) in t ? Object.defineProperty(t, n, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : t[n] = e, t;
}
function Ct() {
  return Ct = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, Ct.apply(this, arguments);
}
function fe(t, n) {
  if (t == null)
    return {};
  var e, r, o = function(l, u) {
    if (l == null)
      return {};
    var c, d, g = {}, p = Object.keys(l);
    for (d = 0; d < p.length; d++)
      c = p[d], u.indexOf(c) >= 0 || (g[c] = l[c]);
    return g;
  }(t, n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (r = 0; r < i.length; r++)
      e = i[r], n.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(t, e) && (o[e] = t[e]);
  }
  return o;
}
function ft(t, n) {
  return n || (n = t.slice(0)), Object.freeze(Object.defineProperties(t, { raw: { value: Object.freeze(n) } }));
}
function pt(t, n) {
  return function(e) {
    if (Array.isArray(e))
      return e;
  }(t) || function(e, r) {
    var o = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (o != null) {
      var i, l, u, c, d = [], g = !0, p = !1;
      try {
        if (u = (o = o.call(e)).next, r === 0) {
          if (Object(o) !== o)
            return;
          g = !1;
        } else
          for (; !(g = (i = u.call(o)).done) && (d.push(i.value), d.length !== r); g = !0)
            ;
      } catch (E) {
        p = !0, l = E;
      } finally {
        try {
          if (!g && o.return != null && (c = o.return(), Object(c) !== c))
            return;
        } finally {
          if (p)
            throw l;
        }
      }
      return d;
    }
  }(t, n) || Se(t, n) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function de(t) {
  return function(n) {
    if (Array.isArray(n))
      return kt(n);
  }(t) || function(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
      return Array.from(n);
  }(t) || Se(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Se(t, n) {
  if (t) {
    if (typeof t == "string")
      return kt(t, n);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    return e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set" ? Array.from(t) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? kt(t, n) : void 0;
  }
}
function kt(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var e = 0, r = new Array(n); e < n; e++)
    r[e] = t[e];
  return r;
}
var at, ct, X, lt, ut, Z, q, st, a = { Top: "top", Bottom: "bottom", Left: "left", Right: "right", CenterVertical: "center-vertical", CenterHorizontal: "center-horizontal" }, s = { Start: "start", Middle: "middle", End: "end", Fit: "fit" };
function gn(t) {
  var n = t.useRelativePositioning, e = t.spacing, r = t.align, o = t.justify, i = t.referenceElViewportPos, l = i === void 0 ? nt : i, u = t.referenceElDocumentPos, c = u === void 0 ? nt : u, d = t.contentElViewportPos, g = d === void 0 ? nt : d, p = t.contentElDocumentPos, E = p === void 0 ? nt : p, j = t.scrollContainer, H = t.windowHeight, L = H === void 0 ? window.innerHeight : H, N = t.windowWidth, W = N === void 0 ? window.innerWidth : N, k = j ? j.offsetWidth : W, G = j ? j.offsetHeight : L, dt = { windowWidth: k, windowHeight: G, referenceElViewportPos: l, contentElViewportPos: g, spacing: e }, T = function(w, m) {
    var v = m.spacing, B = m.windowWidth, M = m.windowHeight, S = m.contentElViewportPos, F = m.referenceElViewportPos, Y = [w].concat(de(wn[w]));
    return Y.find(function(R) {
      return [a.Top, a.Bottom, a.CenterVertical].includes(R) ? me({ top: Rt({ align: R, contentElPos: S, referenceElPos: F, spacing: v }), windowHeight: M, contentHeight: S.height }) : !![a.Left, a.Right, a.CenterHorizontal].includes(R) && pe({ left: $t({ align: R, contentElPos: S, referenceElPos: F, spacing: v }), windowWidth: B, contentWidth: S.width });
    }) || w;
  }(r, dt), U = function(w, m, v) {
    var B, M, S = v.spacing, F = v.windowWidth, Y = v.windowHeight, R = v.contentElViewportPos, P = v.referenceElViewportPos, gt = [w].concat(de(Et[w]));
    switch (m) {
      case a.Top:
      case a.Bottom:
      case a.CenterVertical:
        return (B = gt.find(function(I) {
          return pe({ contentWidth: I === s.Fit ? P.width : R.width, windowWidth: F, left: $t({ contentElPos: R, referenceElPos: P, spacing: S, align: m, justify: I }) });
        })) !== null && B !== void 0 ? B : Et[w][0];
      case a.Left:
      case a.Right:
      case a.CenterHorizontal:
        return (M = gt.find(function(I) {
          return me({ contentHeight: I === s.Fit ? P.height : R.height, windowHeight: Y, top: Rt({ contentElPos: R, referenceElPos: P, spacing: S, align: m, justify: I }) });
        })) !== null && M !== void 0 ? M : Et[w][0];
    }
  }(o, T, dt), rt = function(w) {
    var m, v, B = w.align, M = w.justify, S = mn[B], F = (m = S.x) !== null && m !== void 0 ? m : pn[M], Y = (v = S.y) !== null && v !== void 0 ? v : hn[M];
    return "".concat(F, " ").concat(Y);
  }({ align: T, justify: U }), ot = function(w, m) {
    var v = 0.8;
    switch (w) {
      case a.Top:
        return "translate3d(0, ".concat(m, "px, 0) scale(").concat(v, ")");
      case a.Bottom:
        return "translate3d(0, -".concat(m, "px, 0) scale(").concat(v, ")");
      case a.Left:
        return "translate3d(".concat(m, "px, 0, 0) scale(").concat(v, ")");
      case a.Right:
        return "translate3d(-".concat(m, "px, 0, 0) scale(").concat(v, ")");
      case a.CenterHorizontal:
      case a.CenterVertical:
        return "scale(".concat(v, ")");
    }
  }(T, e);
  return Math.floor(g.width) === 0 && o !== s.Fit ? { align: r, justify: o, positionCSS: { left: 0, top: 0, transform: ot, transformOrigin: rt } } : n ? { align: T, justify: U, positionCSS: et(et({}, bn({ align: T, justify: U, referenceElDocumentPos: c, contentElDocumentPos: E, spacing: e })), {}, { transformOrigin: rt, transform: ot }) } : { align: T, justify: U, positionCSS: et(et({}, yn({ align: T, justify: U, referenceElDocumentPos: c, contentElDocumentPos: E, spacing: e, windowHeight: G, windowWidth: k })), {}, { transformOrigin: rt, transform: ot }) };
}
var nt = { top: 0, bottom: 0, left: 0, right: 0, height: 0, width: 0 }, Ce = function(t, n) {
  var e = t.getBoundingClientRect(), r = e.top, o = e.bottom, i = e.left, l = e.right, u = e.width;
  return { top: r, bottom: o, left: i, right: l, height: t.offsetHeight, width: n ? u : parseFloat(getComputedStyle(t).width) };
};
function ge(t, n, e) {
  if (!t)
    return nt;
  var r = Ce(t, e), o = r.top, i = r.bottom, l = r.left, u = r.right, c = r.height, d = r.width;
  if (n) {
    var g = n.scrollTop, p = n.scrollLeft, E = n.getBoundingClientRect();
    return { top: o + g - E.top, bottom: i + g - E.bottom, left: l + p - E.left, right: u + p - E.right, height: c, width: d };
  }
  var j = window, H = j.scrollX, L = j.scrollY;
  return { top: o + L, bottom: i + L, left: l + H, right: u + H, height: c, width: d };
}
function he(t, n, e) {
  if (!t)
    return nt;
  var r = Ce(t, e), o = r.top, i = r.bottom, l = r.left, u = r.right, c = r.height, d = r.width;
  if (n) {
    var g = n.getBoundingClientRect();
    return { top: o - g.top, bottom: i - g.bottom, left: l - g.left, right: u - g.right, height: c, width: d };
  }
  return { top: o, bottom: i, left: l, right: u, height: c, width: d };
}
var hn = (f(at = {}, s.Start, "top"), f(at, s.Middle, "center"), f(at, s.End, "bottom"), f(at, s.Fit, "center"), at), pn = (f(ct = {}, s.Start, "left"), f(ct, s.Middle, "center"), f(ct, s.End, "right"), f(ct, s.Fit, "center"), ct), mn = (f(X = {}, a.Left, { x: "right" }), f(X, a.Right, { x: "left" }), f(X, a.Top, { y: "bottom" }), f(X, a.Bottom, { y: "top" }), f(X, a.CenterHorizontal, { x: "center" }), f(X, a.CenterVertical, { y: "center" }), X), yt = (f(lt = {}, s.Start, { top: 0 }), f(lt, s.End, { bottom: 0 }), f(lt, s.Middle, function(t) {
  var n = t.contentElDocumentPos, e = t.referenceElDocumentPos;
  return { top: "".concat(e.height / 2 - n.height / 2, "px") };
}), f(lt, s.Fit, { top: 0, bottom: 0 }), lt), wt = (f(ut = {}, s.Start, { left: 0 }), f(ut, s.End, { right: 0 }), f(ut, s.Middle, function(t) {
  var n = t.contentElDocumentPos, e = t.referenceElDocumentPos;
  return { left: "".concat(e.width / 2 - n.width / 2, "px") };
}), f(ut, s.Fit, { left: 0, right: 0 }), ut), vn = (f(Z = {}, a.Top, { constant: function(t) {
  var n = t.spacing;
  return { bottom: "calc(100% + ".concat(n, "px)") };
}, justifyPositions: wt }), f(Z, a.Bottom, { constant: function(t) {
  var n = t.spacing;
  return { top: "calc(100% + ".concat(n, "px)") };
}, justifyPositions: wt }), f(Z, a.CenterVertical, { constant: function(t) {
  var n = t.referenceElDocumentPos;
  return { top: "calc(".concat(n.height / 2, "px - 50%)") };
}, justifyPositions: wt }), f(Z, a.Left, { constant: function(t) {
  var n = t.spacing;
  return { right: "calc(100% + ".concat(n, "px)") };
}, justifyPositions: yt }), f(Z, a.Right, { constant: function(t) {
  var n = t.spacing;
  return { left: "calc(100% + ".concat(n, "px)") };
}, justifyPositions: yt }), f(Z, a.CenterHorizontal, { constant: function(t) {
  var n = t.referenceElDocumentPos;
  return { left: "calc(".concat(n.width / 2, "px - 50%)") };
}, justifyPositions: yt }), Z);
function bn(t) {
  var n, e = t.align, r = t.justify, o = t.referenceElDocumentPos, i = t.contentElDocumentPos, l = t.spacing, u = vn[e], c = u.justifyPositions[r], d = { contentElDocumentPos: i, referenceElDocumentPos: o, spacing: l };
  return et(et({}, (n = u.constant) === null || n === void 0 ? void 0 : n.call(u, d)), typeof c == "function" ? c(d) : c);
}
function yn(t) {
  var n = t.align, e = t.justify, r = t.referenceElDocumentPos, o = t.contentElDocumentPos, i = t.spacing, l = t.windowWidth, u = t.windowHeight, c = $t({ align: n, justify: e, referenceElPos: r, contentElPos: o, spacing: i }), d = "".concat(c, "px"), g = "".concat(Rt({ align: n, justify: e, referenceElPos: r, contentElPos: o, spacing: i }), "px");
  return e !== s.Fit ? { left: d, top: g } : [a.Left, a.Right, a.CenterHorizontal].includes(n) ? { left: d, top: g, bottom: "".concat(u - r.bottom, "px") } : { left: d, top: g, right: "".concat(l - (c + r.width), "px") };
}
function Rt(t) {
  var n = t.align, e = t.justify, r = t.contentElPos, o = t.referenceElPos, i = t.spacing;
  switch (n) {
    case a.Left:
    case a.Right:
    case a.CenterHorizontal:
      switch (e) {
        case s.Start:
        case s.Fit:
          return o.top;
        case s.End:
          return o.top + o.height - r.height;
        case s.Middle:
        default:
          return o.top - (r.height - o.height) / 2;
      }
    case a.CenterVertical:
      return o.top - (r.height - o.height) / 2;
    case a.Top:
      return o.top - r.height - i;
    case a.Bottom:
    default:
      return o.top + o.height + i;
  }
}
function $t(t) {
  var n = t.align, e = t.justify, r = t.contentElPos, o = t.referenceElPos, i = t.spacing;
  switch (n) {
    case a.Top:
    case a.Bottom:
    case a.CenterVertical:
      switch (e) {
        case s.End:
          return o.left + o.width - r.width;
        case s.Middle:
          return o.left - (r.width - o.width) / 2;
        case s.Start:
        case s.Fit:
        default:
          return o.left;
      }
    case a.Left:
      return o.left - r.width - i;
    case a.Right:
      return o.left + o.width + i;
    case a.CenterHorizontal:
    default:
      return o.left - (r.width - o.width) / 2;
  }
}
function pe(t) {
  var n = t.left, e = t.windowWidth, r = t.contentWidth;
  return n >= 0 && !(n + r > e);
}
function me(t) {
  var n = t.top, e = t.windowHeight, r = t.contentHeight;
  return n >= 0 && !(n + r > e);
}
var wn = (f(q = {}, a.Top, [a.Bottom]), f(q, a.Bottom, [a.Top]), f(q, a.Left, [a.Right]), f(q, a.Right, [a.Left]), f(q, a.CenterHorizontal, [a.Left, a.Right]), f(q, a.CenterVertical, [a.Top, a.Bottom]), q), Et = (f(st = {}, s.Start, [s.End, s.Middle]), f(st, s.Middle, [s.End, s.Start]), f(st, s.End, [s.Start, s.Middle]), f(st, s.Fit, [s.Middle, s.Start, s.End]), st), ve, be, ye, we, Ee, En = ["active", "spacing", "align", "justify", "adjustOnMutation", "children", "className", "popoverZIndex", "refEl", "usePortal", "portalClassName", "portalContainer", "portalRef", "scrollContainer", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"], jn = ["transform"], Pn = b(ve || (ve = ft([`
  position: absolute;
  transition: transform `, `ms ease-in-out,
    opacity `, `ms ease-in-out;
  opacity: 0;
`])), xt.default, xt.default), je = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, On = Ze("popover-content"), Pe = _e(function(t, n) {
  var e, r = t.active, o = r !== void 0 && r, i = t.spacing, l = i === void 0 ? 10 : i, u = t.align, c = u === void 0 ? a.Bottom : u, d = t.justify, g = d === void 0 ? s.Start : d, p = t.adjustOnMutation, E = p !== void 0 && p, j = t.children, H = t.className, L = t.popoverZIndex, N = t.refEl, W = t.usePortal, k = W === void 0 || W, G = t.portalClassName, dt = t.portalContainer, T = t.portalRef, U = t.scrollContainer, rt = t.onEnter, ot = t.onEntering, w = t.onEntered, m = t.onExit, v = t.onExiting, B = t.onExited, M = fe(t, En), S = pt(tt(null), 2), F = S[0], Y = S[1], R = pt(tt(null), 2), P = R[0], gt = R[1], I = pt(tt(0), 2), zt = I[0], ke = I[1], Dt = qe().setIsPopoverOpen, Ht = Ke(), it = Ht.portalContainer, V = Ht.scrollContainer;
  it = dt || it, V = U || V, k && V && (V.contains(it) || Je.warn("To ensure correct positioning make sure that the portalContainer element is inside of the scrollContainer"));
  var Lt = D.useRef(P);
  Lt.current = P;
  var J = null;
  if (N && N.current)
    J = N.current;
  else if (F) {
    var mt = F.parentNode;
    mt && mt instanceof HTMLElement && (J = mt);
  }
  var Bt = tn(), Mt = E && o, Re = Gt(J, je, Date.now, Mt), $e = Gt(P == null ? void 0 : P.parentNode, je, Date.now, Mt), ze = ht(he(J, V, !0)), De = ht(he(P == null ? void 0 : P.parentNode, V)), Nt = ht(Ot(function() {
    return ge(J, V, !0);
  }, [J, V, Bt, Re, o, c, g, zt])), He = ht(Ot(function() {
    return ge(P);
  }, [P == null ? void 0 : P.parentNode, Bt, $e, o, c, g, zt])), Tt = Ut(g), Le = Ut(c), Ft = Tt !== g && (g === s.Fit || Tt === s.Fit) || Le !== c && g === s.Fit;
  Yt(function() {
    Ft && ke(function($) {
      return $ + 1;
    });
  }, [Ft]);
  var Vt = pt(tt(!1), 2), Be = Vt[0], Me = Vt[1];
  if (Yt(function() {
    return Me(!0);
  }, []), !Be)
    return null;
  var At, vt = gn({ useRelativePositioning: !k, spacing: l, align: c, justify: g, referenceElViewportPos: ze, referenceElDocumentPos: Nt, contentElViewportPos: De, contentElDocumentPos: He, scrollContainer: V }), Ne = vt.align, Te = vt.justify, Wt = vt.positionCSS, Fe = Wt.transform, Ve = fe(Wt, jn), Ae = b(be || (be = ft([`
      opacity: 1;
      position: `, `;
      pointer-events: initial;
    `])), k ? "" : "absolute"), We = k ? on : Qe, Ie = { className: it ? void 0 : G, container: (e = it) !== null && e !== void 0 ? e : void 0, portalRef: T }, Ge = k ? Ie : {};
  return At = j == null ? null : typeof j == "function" ? j({ align: Ne, justify: Te, referenceElPos: Nt }) : j, D.createElement(rn, { nodeRef: Lt, in: o, timeout: xt.default, mountOnEnter: !0, unmountOnExit: !0, appear: !0, onEntering: ot, onEnter: rt, onEntered: function() {
    Dt(!0);
    for (var $ = arguments.length, z = new Array($), A = 0; A < $; A++)
      z[A] = arguments[A];
    w == null || w.apply(void 0, z);
  }, onExiting: v, onExit: m, onExited: function() {
    Dt(!1);
    for (var $ = arguments.length, z = new Array($), A = 0; A < $; A++)
      z[A] = arguments[A];
    B == null || B.apply(void 0, z);
  } }, function($) {
    var z;
    return D.createElement(D.Fragment, null, D.createElement("span", { ref: Y, className: b(ye || (ye = ft([`
                display: none;
              `]))) }), D.createElement(We, Ge, D.createElement("div", Ct({}, M, { ref: n, className: Oe(Pn, b(Ve), (z = {}, f(z, b({ transform: Fe }), $ === "entering" || $ === "exiting"), f(z, Ae, $ === "entered"), f(z, b(we || (we = ft([`
                      z-index: `, `;
                    `])), L), typeof L == "number"), z), H, f({}, b(Ee || (Ee = ft([`
                      transition-delay: 0ms;
                    `]))), $ === "exiting")) }), D.createElement("div", { ref: gt, className: On }, At))));
  });
});
Pe.displayName = "Popover", Pe.propTypes = { children: y.oneOfType([y.node, y.func]), active: y.bool, className: y.string, align: y.oneOf(Object.values(a)), justify: y.oneOf(Object.values(s)), refEl: y.shape({ current: typeof window < "u" ? y.instanceOf(Element) : y.any }), usePortal: y.bool, portalClassName: y.string, spacing: y.number, adjustOnMutation: y.bool };
export {
  ue as E,
  s as W,
  Rn as c,
  Xt as f,
  Pe as h,
  a as z
};
